import styled from "styled-components";

export const InvoiceWrapper = styled.div`
.invoiceHeader{
    max-width: 94%;
    margin: auto;
}
  .invoiceWrapper {
    max-width: 600px;
    margin: 20px auto;
    padding: 35px 27px;
    background: #fff;
    box-shadow: 0px 2px 3px rgba(0, 41, 112, 0.0509803922);
    border: 1px solid rgba(0, 41, 112, 0.1411764706);
    border-radius: 10px;
    opacity: 1;

    .logo {
      & > div {
        line-height: 13px;
        font-size: 10px;
      }
    }
  }

  .commission-note {
  /* display: flex;
  align-items: center; */
  gap: 4px;
  padding: 12px 16px;
  margin-top: 12px;
  background: rgba(221, 168, 83, 0.1);
  border: 1px solid rgba(221, 168, 83, 0.25);
  border-left: 4px solid #dda853;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.5;
  color: #4b5563;

  .commission {
    font-weight: 700;
    color: #16a34a;
  }

  .amount {
    font-weight: 700;
    color: #111827;
  }
}

@media screen and (max-width: 767px)  {
  .commission-note {
  padding: 12px 16px;
  background: rgba(221, 168, 83, 0.1);
  border-left: 4px solid #dda853;
  border-radius: 10px;
  font-size: 14px;
  color: #4b5563;
  line-height: 1.5;

  .commission {
    color: #16a34a;
    font-weight: 700;
  }

  .amount {
    color: #111827;
    font-weight: 700;
  }
}
}
`;
